import {dbg, find, findAll} from "../../functions"

/**
 * @class userHandler
 * @param {string} dataClassGiven - the CSS class to find user data
 * @param {object} cPM - the cPM instance to manage the form
 * @description This class retrieves user data from the frontend, pre-fills form fields, and manages address options.
 */
export default class userHandler {
    constructor(dataClassGiven, cPM) {
        this.dataClass = dataClassGiven
        this.userdata = this.getUserdata()
        this.cPM = cPM
        this.adressSkeleton = document.querySelector(".powermail_fieldwrap_aadress .radio")

        if (this.userdata) {
            ;[
                this.uid,
                this.firstname,
                this.middlename,
                this.lastname,
                this.telephone,
                this.email,
                this.company,
                this.aadress,
                this.zip,
                this.city,
                this.handynummer,
                this.betriebsnummer
            ] = this.userdata
            this.aadress = "not set yet"
        } else {
            console.warn("userHandler: no userdata found")
            this.uid = ""
        }
        this.prefillTextInput("#powermail_field_vorname", this.firstname)
        this.prefillTextInput("#powermail_field_nachname", this.lastname)
        this.prefillTextInput("#powermail_field_telefonnummer", this.telephone)
        this.prefillTextInput("#powermail_field_handynummer", this.handynummer)
        this.prefillTextInput("#powermail_field_betriebsnummer", this.betriebsnummer)
        this.addCustomerNumber()
    }

    /**
     * looks for user-data in frontend and pushes all values into userdataArray
     * @returns {array} userdataArray
     */
    getUserdata() {
        let elem = document.querySelector(this.dataClass).querySelector(".user-csv")
        if (elem) {
            return elem.innerText.trim().split(",")
        } else {
            // console.warn("getUserdata: no element found:", this.dataClass);
            return false
        }
    }

    /**
     * checks if the name inputs are empty and fills them with the user data
     * @returns {void}
     */
    checkNameInputs() {
        let input = document.querySelector("#powermail_field_vorname")
        if (input && !input.value) {
            input.value = this.firstname
        } else if (!input) {
            console.warn("checkNameInputs: no input found for #powermail_field_vorname")
        }
    }

    /**
     * prefills the 'selector' textInputs with given value
     * @param {string} selector - the CSS selector for the input element
     * @param {string} value - the value to prefill the input with
     * @returns {boolean} - true if the input was successfully prefilled, false otherwise
     */
    prefillTextInput(selector, value) {
        let elem = document.querySelector(selector)
        if (elem && value && !elem.value) {
            elem.value = value
            return true
        } else if (!elem) {
            // console.warn(`prefillTextInput: no element found for selector: ${selector}, value: ${value}`);
        }
        return false
    }

    /**
     * adds the customer number to the form
     * @returns {void}
     */
    addCustomerNumber() {
        let elemToAppendAfter = document.querySelector(".powermail_fieldwrap_ihredaten")
        let numberContainer = document.querySelector("#user-id")
        let display = document.createElement("div")
        let head = document.createElement("h5")
        let newID = document.createElement("ul")
        let ncId, ncName, type = true
        if (numberContainer) {
            ncId = numberContainer.dataset.userid
            ncName = numberContainer.dataset.username
        } else {
            ncId = undefined
            ncName = undefined
        }
        let id = ""

        if (!numberContainer || !elemToAppendAfter) {
            console.warn("addCustomerNumber: required DOM elements not found", elemToAppendAfter, numberContainer)
            return
        }

        if (ncId.length === 6) {
            id = ncId
        } else if (ncName.length === 6) {
            id = ncName
        } else if (ncName.substring(0,3) === "neu") {
            id = ncName
            type = false
        } else {
            id = ncName
            console.warn("addCustomerNumber: no valid id found: id: ", ncId, "  name: ", ncName)
        }

        display.setAttribute("id", "customer-number")
        head.textContent = "Kundennummer "
        display.appendChild(head)
        newID.setAttribute("id", "newID")

        /* given ID */
        if (id != undefined && type) {
            id.split("").forEach((int) => {
                let itm = document.createElement("li")
                itm.className = "id-split"
                itm.innerText = int
                newID.appendChild(itm)
            })
        }

        /* new ID */
        if(!type) {
            let itm = document.createElement("div")
            itm.className = "id-new"
            itm.innerHTML =  "<strong>(vorläufig)</strong> " + ncName
            newID.appendChild(itm)
            newID.classList.add("new-id")
        }

        display.appendChild(newID)
        elemToAppendAfter.appendChild(display)
    }

    addAdresses() {
        let radioElem =
            document.querySelector(".powermail_fieldwrap_aadress .powermail_field") ||
            document.querySelector(".powermail_fieldwrap_aadress .")
        let safedAdresses = document.querySelectorAll(`#safed-adresses > .ua-${this.uid}-address`)
        if (!safedAdresses.length) {
            safedAdresses = document.querySelectorAll("#safed-adresses > div")
        }
        if (!radioElem) {
            console.error("addAdresses: no radioElem found", radioElem, safedAdresses)
            return
        }
        if (safedAdresses.length > 0) {
            safedAdresses.forEach((el) => {
                let contentElem = el.querySelector(".content")
                if (contentElem && contentElem.innerText !== "") {
                    let value = contentElem.innerText
                    let it = el.dataset.iteration
                    if (it !== undefined) {
                        this.appendAdressOption(it, "", value)
                    } else {
                        console.error("addAdresses: no iteration in safedAdresses", el)
                    }
                } else {
                    console.warn("addAdresses: no content found in safedAdresses", el)
                }
            })
        } else {
            this.appendFirstAdressOption()
        }
    }

    /**
     * adds a new adress string into appendAdressOption
     * @param {string} newAdressString
     */
    appendNewAdress(newAdressString) {
        var arr = findAll(".powermail_fieldwrap_aadress .radio"),
            arrl = arr.length
        var id = arrl
        this.cPM.newAdressArray.push(newAdressString)
        this.appendAdressOption(id, false, newAdressString)
    }

    /**
     * adds a new adress to the list of adresses
     * @param {int} iteration
     * @param {HTMLElement|null|string} el
     * @param {string} newAdressString
     */
    appendAdressOption(iteration, el, newAdressString) {
        let skeleton = this.adressSkeleton
        if (!skeleton) {
            console.error("appendAdressOption: adressSkeleton not found")
            return
        }
        let elem = skeleton.cloneNode(true)
        let newId = parseInt(iteration, 10) + 1
        let adressString = ""
        elem.setAttribute("it", iteration)
        elem.setAttribute("data-custom", "true")
        if (el) {
            let {firstname: fn, lastname: ln, address: adr, zip, city, telephone: tel} = el.dataset
            adressString = `${fn} ${ln}, ${adr}, ${zip} ${city}, ${tel}`
        } else if (newAdressString) {
            adressString = newAdressString
        } else {
            adressString = "data-verification failed"
        }
        let input = elem.children[0]?.children[0]
        if (input) {
            input.value = adressString
            input.setAttribute("id", `powermail_field_aadress_${newId}`)
            if (input.nextSibling) {
                input.nextSibling.data = adressString
            }
        } else {
            console.error("appendAdressOption: element children not found")
        }
        if (!document.querySelector(`#powermail_field_aadress_${newId}`)) {
            skeleton.before(elem)
        }
    }

    /**
     * sets the user input as adress option
     */
    setUserAdressAsOption() {
        let firstname = document.querySelector("#powermail_field_vorname")
        let lastname = document.querySelector("#powermail_field_nachname")
        let tel = document.querySelector("#powermail_field_telefonnummer")
        let street = document.querySelector("#powermail_field_strasseundhausnummer")
        let zip = document.querySelector("#powermail_field_plz")
        let city = document.querySelector("#powermail_field_ort")

        if ([firstname, lastname, city, zip, tel].every((f) => f && f.value)) {
            let adressString = `${firstname.value} ${lastname.value}, ${street.value}, ${zip.value} ${city.value}, ${tel.value}`
            this.cPM.enableSubmit()
            this.aadress = adressString
            return adressString
        } else {
            this.cPM.disableSubmit()
            this.aadress = "Fehlende Daten!"
            return this.aadress
        }
    }

    /**
     * adds the first adress option to the form -
     * the 'first' means here the one built with user inputs in step1
     */
    appendFirstAdressOption() {
        let origin = document.querySelector(".powermail_fieldwrap_aadress .radio")
        if (!origin) {
            console.error("appendFirstAdressOption: origin radio not found")
            return
        }
        let cl = origin.cloneNode(true)
        let adressString = this.setUserAdressAsOption()
        let input = cl.children[0]?.children[0]

        cl.setAttribute("it", "0")
        cl.setAttribute("data-custom", "true")
        if (input) {
            input.defaultValue = adressString
            input.value = adressString
            input.setAttribute(
                "data-powermail-required-message",
                "Bitte wählen Sie eine Abholungsadresse, oder fügen Sie eine neue hinzu!"
            )
            if (input.nextSibling) {
                input.nextSibling.data = `${adressString}\n\t`
            }
        }

        origin.after(cl)
        origin.remove()
    }
}
